import React from 'react';
import { UiTable, UiSpacer } from 'src/ui';
import { Button, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;
;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import propTypes from 'prop-types';

export const ComplianceTaskAccountTable = ({
  data,
  type,
  setAccountTaskModal,
  setEmailTaskModal,
}) => {
  const tableColumns = [
    {
      Header: 'Account Name',
      accessor: 'accountName',
      filterMethod: (_filter, row) => {
        return [row._original.accountName].some(v =>
          v.toLowerCase().includes(_filter.value.toLowerCase())
        );
      },
      Cell: row => (
        <div className="account-name">
          {/* eslint-disable-next-line */}
          <a
            className="edit-link"
            onClick={() =>
              setAccountTaskModal({
                data: row.original,
                isActive: true,
                taskType: type,
                formType: 'Edit',
              })
            }
          >
            {row.original.accountName}
          </a>
        </div>
      ),
    },
    {
      Header: 'Status',
      accessor: 'isActive',
      filterable: false,

      Cell: row => (
        <div className="has-text-grey-medium-dark">
          {row.original.isActive ? 'Active' : 'Inactive'}
        </div>
      ),
    },
    {
      Header: 'Task Frequency',
      accessor: 'frequency',
      filterMethod: (_filter, row) => {
        return [row._original.frequency].some(v =>
          v.toLowerCase().includes(_filter.value.toLowerCase())
        );
      },
      Cell: row => (
        <div className="has-text-grey-medium-dark">
          {row.original.frequency}
        </div>
      ),
    },
    {
      Header: '',
      accessor: 'id',
      sortable: false,
      width: 62,
      resizable: false,
      filterable: false,
      Cell: row => (
        <MuiDropdown
          isAlign="right"
          renderTrigger={
            <Button className="transparent-elipses">
              <span className="icon transparent-elipses">
                <FontAwesomeIcon
                  icon={['fal', 'ellipsis-v']}
                  className="has-text-grey transparent-elipses"
                  size="lg"
                  style={{ background: 'transparent' }}
                />
              </span>
            </Button>
          }
        >
            <MuiDropdownItem
              tag="a"
              onClick={() =>
                setAccountTaskModal({
                  data: row.original,
                  isActive: true,
                  taskType: type,
                  formType: 'Edit',
                })
              }
            >
              Edit Task
            </MuiDropdownItem>
            <MuiDropdownItem
              tag="a"
              onClick={() =>
                setEmailTaskModal({
                  data: row.original.taskEmailList,
                  isActive: true,
                  taskId: row.original.taskId,
                  accountName: row.original.accountName,
                })
              }
            >
              Edit Notifications
            </MuiDropdownItem>
        </MuiDropdown>
      ),
    },
  ];
  return (
    <>
      <UiSpacer />
      <UiTable
        className="people-table -highlight"
        isAlign="right"
        columns={tableColumns}
        data={data}
        useTablePagination
        title="Accounts"
        resolveData={data =>
          data.map(transaction => ({
            ...transaction,
          }))
        }
        hidePrev
        hideNext
        hideButton
        filterable
        pageSize={5}
      />
    </>
  );
};

ComplianceTaskAccountTable.propTypes = {
  data: propTypes.array.isRequired,
  type: propTypes.string.isRequired,
  setAccountTaskModal: propTypes.func.isRequired,
  setEmailTaskModal: propTypes.func.isRequired,
};
